module.exports = function() {
  return new Worker(__webpack_public_path__ + "27ab6c8de59ae27591c5.worker.js");
};